// Copied from setup-web/src/lib/sso.js

/**
 * @param {string} documentCookie Cookie for test. Leave out to use real browser cookie
 * @return {{email: string, accessToken: string} | null} User Auth Information
 */
function initialAuthUserFromCookie(documentCookie) {
	const cookie = getUserCookie(documentCookie);

	if (!cookie || !cookie.authenticated) {
		return null;
	}
	return {
		email: cookie.authenticated.username,
		accessToken: cookie.authenticated.access_token
	};
}

/**
 * @param {string} documentCookie Cookie for test. Leave out to use real browser cookie
 * @return  {object | null} cookie Data
 */
function getUserCookie(documentCookie = document.cookie, cookieDomain = process.env.GATSBY_COOKIE_DOMAIN) {
	// Cannot use a library like cookies-next since it returns the first cookie it finds by name
	// whereas we need to match the cookie against the cookieDomain
	const cookieName = 'ember_simple_auth_session';
	const allCookies = documentCookie.split('; ').map((x) => x.split('=').map(decodeURIComponent));
	const matchingCookies = [];
	allCookies.forEach(([name, value]) => {
		if (name === cookieName) {
			try {
				const data = JSON.parse(value);
				matchingCookies.push(data);
			} catch (error) {
				// ignore invalid cookies
			}
		}
	});

	let cookieBlankDomain = null;
	// First try exact match on domain
	for (const cookie of matchingCookies) {
		if (cookie.domain === cookieDomain) {
			return cookie;
		} else if (!cookie.domain) {
			cookieBlankDomain = cookie;
		}
	}

	// Return cookie without a domain if one is available
	return cookieBlankDomain;
}

module.exports = {
  initialAuthUserFromCookie,
  getUserCookie
};
